import React from "react";
import "./text-shimmer.css";

export function TextShimmer({ children, className = "" }) {
  return (
    <span className={`text-shimmer${className ? ` ${className}` : ""}`}>
      {children}
    </span>
  );
}
